<template>
  <div class="tab">
    <!-- <ul>
      <li><a onclick="toggleTab('profile')">公司简介</a></li>
      <li><a onclick="toggleTab('qualification')">公司资质</a></li>
      <li><a onclick="toggleTab('team')">顾问团队</a></li>
      <li><a onclick="toggleTab('recruit')">公司招聘</a></li>
    </ul> -->
    <router-link :to="'/aboutus/profile'" :class="{ 'active': isCurrentPage('profile') }">公司简介</router-link>
    <router-link :to="'/aboutus/qualification'" :class="{ 'active': isCurrentPage('qualification') }">公司资质</router-link>
    <!-- <router-link :to="'/aboutus/team'">顾问团队</router-link> -->
    <router-link :to="'/aboutus/recruit'" :class="{ 'active': isCurrentPage('recruit') }">公司招聘</router-link>
  </div>
</template>

<script>
export default {
  methods: {
    isCurrentPage(name) {
      let currentName = "";
      switch (this.$route.name) {
        case "aboutus-profile":
          currentName = "profile";
          break;
        case "aboutus-qualification":
          currentName = "qualification";
          break;
        case "aboutus-team":
          currentName = "team";
          break;
        case "aboutus-recruit":
          currentName = "recruit";
          break;
        default:
          break;
      }
      // console.log(111111111, this.$route.name, name, currentName);

      return name === currentName;
    }
  },
  computed: {
    currentPage: function() {
      switch (this.$route.name) {
        case "aboutus-profile":
          return "profile";
        case "aboutus-qualification":
          return "qualification";
        case "aboutus-team":
          return "team";
        case "aboutus-recruit":
          return "recruit";
        default:
          return null;
      }
    }
  }
};
</script>

<style lang="scss" scope>
.tab {
  display: flex;
  justify-content: center;
  list-style-type: none;
  padding: 30px 20%;

  a {
    color: #505050;
    font-weight: 600;
    text-decoration: none;
    // cursor: pointer;
    padding-bottom: 5px;
    margin: 0 20px;

    &:hover,
    &:focus {
      color: #145a84;
      background-color: #fffbfb;
      border-bottom: 2px solid #145a84;
    }

    // &:target {
    //   display: flex;
    //   color: red;
    // }
  }

  .active {
    color: #145a84;
    background-color: #fffbfb;
    border-bottom: 2px solid #145a84;
  }
}
</style>